// extracted by mini-css-extract-plugin
export default {"slider":"CourseSlider_slider__tHq7t","prev-arrow":"CourseSlider_prev-arrow__aJ0jW","next-arrow":"CourseSlider_next-arrow__935ce","container":"CourseSlider_container__Rms0g"};